import {runSafe} from "../utils";

export function initCooldownButtons(element: Element) {
  runSafe(() => {
    const cooldownButtons = element.querySelectorAll(".cooldown-button");
    for (const cooldownButton of cooldownButtons) {
      if (cooldownButton instanceof HTMLButtonElement) {
        new CooldownButton(cooldownButton);
      }
    }
  });
}

export class CooldownButton {
  private readonly button: HTMLButtonElement;
  private readonly cooldownContent: HTMLElement|null;
  private readonly timeRegex = /(\d{2}):(\d{2})/;
  private timerId: number|null = null;

  constructor(button: HTMLButtonElement) {
    this.button = button;
    this.cooldownContent = button.querySelector(".cooldown-button__cooldown-content");

    (button as any).__cooldownInstance = this;

    this.init();
  }

  private init() {
    const seconds = this.extractSeconds(this.cooldownContent?.textContent ?? null);
    if (seconds) {
      this.startCountdown(seconds);
    }
  }

  private extractSeconds(text: string|null): number|null {
    if (!text) {
      return null;
    }

    const match = text.match(this.timeRegex);
    if (!match) {
      return null;
    }

    return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
  }

  private startCountdown(secondsLeft: number) {
    this.updateCooldownText(secondsLeft);

    this.timerId = window.setInterval(() => {
      secondsLeft--;
      if (secondsLeft <= 0) {
        this.clearCooldown();
      } else {
        this.updateCooldownText(secondsLeft);
      }
    }, 1000);

    this.button.classList.add("cooldown-button_cooldown-active");
    this.button.disabled = true;
  }

  private updateCooldownText(secondsLeft: number) {
    if (!this.cooldownContent) {
      return;
    }

    const mm = String(Math.floor(secondsLeft / 60)).padStart(2, "0");
    const ss = String(secondsLeft % 60).padStart(2, "0");
    const newTime = `${mm}:${ss}`;
    this.cooldownContent.textContent = this.cooldownContent.textContent!.replace(this.timeRegex, newTime);
  }

  private clearCooldown() {
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    this.button.classList.remove("cooldown-button_cooldown-active");
    this.button.disabled = false;
  }

  public restart(seconds: number) {
    if (seconds === 0) {
      this.clearCooldown();
      return;
    }

    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    this.startCountdown(seconds);
  }

  public get currentClass(): string {
    return this.button.className;
  }

  static getInstance(button: HTMLButtonElement): CooldownButton|null {
    return (button as any).__cooldownInstance ?? null;
  }
}